import { render } from "./GraphReportsTotals.vue?vue&type=template&id=34c63a5d"
import script from "./GraphReportsTotals.vue?vue&type=script&lang=js"
export * from "./GraphReportsTotals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__